// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  presenceId: __t.u64(),
  sessionId: __t.option(__t.u64()),
  positionX: __t.f64(),
  positionY: __t.f64(),
  positionZ: __t.f64(),
  rotationPitch: __t.f32(),
  rotationYaw: __t.f32(),
  rotationRoll: __t.f32(),
  velocityX: __t.f32(),
  velocityY: __t.f32(),
  velocityZ: __t.f32(),
  sequenceNumber: __t.u64(),
};
